var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48.0001,
    rx: 24,
    fill: "#FDBA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0609 23.9762V16.4893C33.0609 16.2988 32.9853 16.116 32.8505 15.9812L29.0797 12.2105C28.945 12.0758 28.7622 12.0001 28.5717 12.0001H14.6177C14.2209 12.0001 13.8992 12.3218 13.8992 12.7186V35.2337C13.8992 35.6306 14.2209 35.9523 14.6177 35.9523H22.2824",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6896 21.581H28.2705M18.6896 16.7905H23.48M18.6896 26.3714H22.2824",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6109 29.8916L31.8085 28.694C32.3329 28.1696 33.1832 28.1696 33.7076 28.694C34.2321 29.2184 34.2321 30.0687 33.7076 30.5932L32.51 31.7908M30.6109 29.8916L27.0287 33.4738C26.8492 33.6533 26.7313 33.8853 26.6923 34.136L26.4016 36L28.2655 35.7095C28.5164 35.6703 28.7482 35.5525 28.9277 35.3729L32.51 31.7908M30.6109 29.8916L32.51 31.7908",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2704 12.0001V16.0719C28.2704 16.4688 28.5921 16.7905 28.989 16.7905H33.0608",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.9691b6ad5959b3db0c59e0f29eec9003.svg";
export { ForwardRef as ReactComponent };